import React, { Component } from 'react';

import { CurrencyIcon } from '../../Assets/Settings/SettingsIcon';

import CurrencyForm from '../../Components/Form/CurrencyForm/CurrencyForm';
import FormLayout from '../../Components/Layout/FormLayout';

class UpdateCurrency extends Component {
  componentDidMount() {
    document.title = 'Edit Currency';
  }

  renderCurrencyForm() {
    return (
      <CurrencyForm
        type="edit"
        handleToast={this.props.handleToast}
        id={this.props.id}
        closeEditmodal={this.props.closeEditmodal}
        fetchDataWithQueryString={this.props.fetchDataWithQueryString}
      />
    );
  }

  render() {
    return <div>{this.renderCurrencyForm()}</div>;
  }
}

export default UpdateCurrency;
